import React from 'react';
import axiosInstance from '../api/axiosInstance'; // Import axiosInstance
import './WorkOrderHistoryModal.css';

function WorkOrderHistoryModal({ isOpen, onClose, doneWorkOrders }) {
  const handleExcelDownload = async () => {
    try {
      const response = await axiosInstance.get('/excel/work-order-history', {
        responseType: 'blob', // Important for binary data
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;

      const today = new Date();
      const year = today.getFullYear().toString().slice(-2);
      const month = (today.getMonth() + 1).toString().padStart(2, '0');
      const day = today.getDate().toString().padStart(2, '0');
      const dateString = `${year}.${month}.${day}`;
      const filename = `작업처리내역_${dateString}.xlsx`;

      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error('Error downloading work order history Excel file:', error);
      alert('작업 처리 내역 엑셀 파일 다운로드 중 오류가 발생했습니다.');
    }
  };

  if (!isOpen) return null;

  // Filter to ensure only 'done' status items are processed
  const filteredDoneWorkOrders = doneWorkOrders.filter(order => order.status === 'done');

  // Group work orders by completedAt date
  const groupedByDate = filteredDoneWorkOrders.reduce((acc, order) => {
    let dateKey;
    if (order.completedAt) {
      // console.log('Original completedAt:', order.completedAt);
      dateKey = order.completedAt.split('T')[0]; // Get YYYY-MM-DD part
      // console.log('Formatted dateKey:', dateKey);
    } else {
      // Fallback for older items or if completedAt is not set
      dateKey = '날짜 미정'; 
    }

    if (!acc[dateKey]) {
      acc[dateKey] = [];
    }
    acc[dateKey].push(order);
    return acc;
  }, {});

  // Sort dates in descending order
  const sortedDates = Object.keys(groupedByDate).sort((a, b) => b.localeCompare(a));

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content work-order-history-modal" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="modal-close-button">×</button>
        <h2>작업 처리 내역</h2>
        <div style={{ textAlign: 'right', marginBottom: '20px' }}>
          <button onClick={handleExcelDownload} className="register-button">
            엑셀 다운로드
          </button>
        </div>

        {sortedDates.length > 0 ? (
          sortedDates.map(date => (
            <div key={date} className="history-date-group">
              <h3>{date}</h3>
              <ul className="history-list">
                {groupedByDate[date].map(order => (
                  <li key={order.id} className="history-item">
                    {(() => {
                      const title = order.title;
                      let displayTitle = title;
                      let deploymentDate = null;

                      // "YYYY-MM-DD 배치" 패턴을 찾는 정규식
                      const regex = /(\d{4}-\d{2}-\d{2} 배치)/;
                      const match = title.match(regex);

                      if (match) {
                        deploymentDate = match[1]; // 매치된 전체 문자열 (예: "2025-08-07 배치")
                        displayTitle = title.replace(regex, '').trim(); // 제목에서 해당 부분 제거
                      }

                      // 공사번호 패턴을 찾는 정규식 (예: [3992-2024-5295])
                      const taskNumberRegex = /\[(\d{4}-\d{4}-\d{4})\]/;
                      const taskNumberMatch = displayTitle.match(taskNumberRegex);

                      if (taskNumberMatch) {
                        displayTitle = displayTitle.replace(taskNumberRegex, '').trim(); // 제목에서 공사번호 부분 제거
                      }

                      let parsedDetails = order.details;
                      if (typeof parsedDetails === 'string') {
                        try {
                          parsedDetails = JSON.parse(parsedDetails);
                        } catch (e) {
                          console.error("Failed to parse details JSON in history modal:", order.id, e);
                          parsedDetails = {};
                        }
                      }

                      return (
                        order.type === '배치' ? (() => {
                          let dateDisplay = '';
                          if (parsedDetails && parsedDetails.assignments && parsedDetails.assignments.length > 0) {
                            const dates = parsedDetails.assignments.map(a => a.assignmentDate).sort();
                            const startDate = dates[0];
                            const endDate = dates[dates.length - 1];
                            if (startDate === endDate) {
                              dateDisplay = `${startDate} 배치`;
                            } else {
                              dateDisplay = `${startDate} ~ ${endDate} 배치`;
                            }
                          } else if (deploymentDate) {
                            dateDisplay = deploymentDate;
                          }

                          return (
                            <>
                              {dateDisplay && <p><strong>{order.type} :</strong> {dateDisplay}</p>}
                              <p><strong>공사명:</strong> {displayTitle}</p>
                              {parsedDetails && parsedDetails.taskNumber && (
                                <div className="history-item-row">
                                  <p><strong>공사번호:</strong> {parsedDetails.taskNumber}</p>
                                </div>
                              )}
                              {parsedDetails && parsedDetails.assignments && (
                                <div className="history-item-row">
                                  <p><strong>책임:</strong> {parsedDetails.assignments[0]?.assignedManagers}</p>
                                  <p><strong>보조:</strong> {parsedDetails.assignments[0]?.assignedAssistants || '없음'}</p>
                                </div>
                              )}
                            </>
                          );
                        })() : order.type === '시공통보' ? (
                          <>
                            <p><strong>종류:</strong> 시공통보</p>
                            <p><strong>공사명:</strong> {parsedDetails.noticeDetails || '내용 없음'}</p>
                            <div className="history-item-row">
                              <p><strong>책임:</strong> {parsedDetails.principalSupervisor || '미지정'}</p>
                              <p><strong>보조:</strong> {parsedDetails.assistantSupervisor || '없음'}</p>
                            </div>
                          </>
                        ) : order.type === '기타' ? (
                          <>
                            <p><strong>종류:</strong> 기타</p>
                            <p><strong>제목:</strong> {parsedDetails.otherTitle || '제목 없음'}</p>
                            <p><strong>내용:</strong> {parsedDetails.otherDetails ? (parsedDetails.otherDetails.length > 50 ? parsedDetails.otherDetails.substring(0, 50) + '...' : parsedDetails.otherDetails) : '내용 없음'}</p>
                          </>
                        ) : (
                          <>
                            <p><strong>제목:</strong> {order.title}</p>
                            <p><strong>종류:</strong> {order.type}</p>
                          </>
                        )
                      );
                    })()} 
                  </li>
                ))}
              </ul>
            </div>
          ))
        ) : (
          <p>완료된 작업이 없습니다.</p>
        )}
      </div>
    </div>
  );
}

export default WorkOrderHistoryModal;